module.exports = __webpack_public_path__ + "static/media/history.97437e22.svg";